'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.lost-password-form', function () {
    const $form = $(this);
    const email = $form.find('#user_email').val();
    const $submit = $form.find('button[type=submit]');

    if (!email) {
      $('#user_email').focus();
      return false;
    }

    $submit.addClass('button-loading').prop('disabled', true);
  });
});
